import { localizedRoutes, localizedLocale } from '../mixins/localization'
import { getArticles, getMedia, getMixCategories, getProductCategories, getProducts } from './api'

const view = (v) => () => import(`@/views/${v}.vue`)

const applicationViews = [
  {
    path: '',
    name: 'rootPath',
    component: view('home/index'),
    props: true,
    meta: { layout: 'base' },
  },
  {
    path: `/${localizedRoutes('path.search')}/:search?`,
    name: 'searchPath',
    component: view('search/index'),
    meta: { sitemap: { ignoreRoute: true }, layout: 'base' },
  },
  {
    name: 'productsPath',
    path: `/${localizedRoutes('path.products')}/:permalink`,
    component: view('products/index'),
    meta: { sitemap: { slugs: async () => await getProductCategories() }, layout: 'base', scrollToSavedPositionOnceReady: true },
  },
  {
    name: 'productPath',
    path: `/${localizedRoutes('path.product')}/:permalink`,
    component: view('products/show'),
    meta: { sitemap: { slugs: async () => await getProducts() }, customPageView: true, layout: 'base' },
  },
  {
    name: 'signUpPath',
    path: `/${localizedRoutes('path.sign_up')}`,
    component: view('sign_up/new'),
    meta: { layout: 'base' },
  },
  {
    name: 'signInPath',
    path: `/${localizedRoutes('path.sign_in')}`,
    component: view('sign_in/new'),
    meta: { layout: 'base' },
  },
  {
    name: 'ordersPath',
    path: `/${localizedRoutes('path.orders')}`,
    component: view('customers/customer_orders/index'),
    meta: { sitemap: { ignoreRoute: true }, blockRobots: true, requiresAuth: true, layout: 'base' },
  },
  {
    name: 'orderPath',
    path: `/${localizedRoutes('path.order')}/:hash`,
    component: view('customers/customer_orders/show'),
    meta: { sitemap: { ignoreRoute: true }, blockRobots: true, layout: 'base' },
  },
  {
    name: 'ordersStatusPath',
    path: `/${localizedRoutes('path.orders_status')}/:hash`,
    component: view('orders/status'),
    meta: { sitemap: { ignoreRoute: true }, blockRobots: true, layout: 'base' },
  },
  {
    name: 'customerProfilePath',
    path: `/${localizedRoutes('path.customer-profile')}`,
    component: view('customers/customers_profile/show'),
    meta: { sitemap: { ignoreRoute: true }, blockRobots: true, requiresAuth: true, layout: 'base' },
  },
  {
    name: 'customerAddressesPath',
    path: `/${localizedRoutes('path.customer-addresses')}`,
    component: view('customers/customer_addresses/index'),
    meta: { sitemap: { ignoreRoute: true }, blockRobots: true ,requiresAuth: true, layout: 'base' },
  },
  {
    name: 'customerAddressesEditPath',
    path: `/${localizedRoutes('path.customer-addresses-edit')}/:id`,
    component: view('customers/customer_addresses/edit'),
    meta: { sitemap: { ignoreRoute: true }, blockRobots: true ,requiresAuth: true, layout: 'base' },
  },
  {
    name: 'customerCreditsPath',
    path: `/${localizedRoutes('path.customer-credits')}`,
    component: view('customers/customer_credits/index'),
    meta: { sitemap: { ignoreRoute: true }, blockRobots: true ,requiresAuth: true, layout: 'base' },
  },
  {
    name: 'customerRatingsPath',
    path: `/${localizedRoutes('path.customer-ratings')}`,
    component: view('customers/customer_ratings/index'),
    meta: { sitemap: { ignoreRoute: true }, blockRobots: true, requiresAuth: true, layout: 'base' },
  },
  {
    name: 'customerBadges',
    path: `/${localizedRoutes('path.customer-badges')}`,
    component: view('customers/customer_badges/index'),
    meta: { sitemap: { ignoreRoute: true }, blockRobots: true, requiresAuth: true, layout: 'base' },
  },
  {
    name: 'customerMixesPath',
    path: `/${localizedRoutes('path.customer-mixes')}`,
    component: view('customers/customer_mixes/index'),
    meta: { sitemap: { ignoreRoute: true }, blockRobots: true, requiresAuth: true, layout: 'base' },
  },
  {
    name: 'customerWatchdogProductsPath',
    path: `/${localizedRoutes('path.customer-watchdog-product')}`,
    component: view('customers/customer_watchdog_products/index'),
    meta: { sitemap: { ignoreRoute: true }, blockRobots: true, requiresAuth: true, layout: 'base' },
  },
  {
    name: 'customerSupportPath',
    path: `/${localizedRoutes('path.customer-support')}`,
    component: view('customers/customer_support/index'),
    meta: { sitemap: { ignoreRoute: true }, blockRobots: true, requiresAuth: true, layout: 'base' },
  },
  {
    name: 'customerSettingsPath',
    path: `/${localizedRoutes('path.customer-settings')}`,
    component: view('customers/customer_settings/index'),
    meta: { sitemap: { ignoreRoute: true }, blockRobots: true, requiresAuth: true, layout: 'base' },
  },
  {
    name: 'passwordsNewPath',
    path: `/${localizedRoutes('path.passwords-new')}`,
    component: view('customers/passwords/new'),
    meta: { sitemap: { ignoreRoute: true }, blockRobots: true, layout: 'base' },
  },
  {
    name: 'passwordsEditPath',
    path: `/${localizedRoutes('path.passwords-edit')}/:token`,
    component: view('customers/passwords/edit'),
    meta: { sitemap: { ignoreRoute: true }, blockRobots: true, layout: 'base' },
  },
  {
    name: 'blogPath',
    path: `/${localizedRoutes('path.blog')}`,
    component: view('blog/index'),
    meta: { layout: 'base' },
  },
  {
    name: 'showBlogPath',
    path: `/${localizedRoutes('path.blog')}/:permalink`,
    component: view('blog/show'),
    meta: { sitemap: { slugs: async () => await getArticles() }, layout: 'base' },
  },
  {
    name: 'aboutUsPath',
    path: `/${localizedRoutes('path.about-us')}`,
    component: view('about_us/index'),
    meta: { layout: 'base' },
  },
  {
    name: 'contactPath',
    path: `/${localizedRoutes('path.contact')}`,
    component: view('contact/index'),
    meta: { layout: 'base' },
  },
  {
    name: 'clubPath',
    path: `/${localizedRoutes('path.club')}`,
    component: view('club/index'),
    meta: { sitemap: { ignoreRoute: !(localizedLocale() === 'cs' || localizedLocale() === 'sk') }, blockRobots: !(localizedLocale() === 'cs' || localizedLocale() === 'sk'), layout: 'base' },
  },
  {
    name: 'mixitPlusPath',
    path: `/${localizedRoutes('path.mixit-plus')}`,
    component: view('mixit_plus/index'),
    meta: { layout: 'base' },
  },
  {
    name: 'clubMembershipPaymentPath',
    path: `/${localizedRoutes('path.club_memberships_payment')}/:hash`,
    component: view('club/payment'),
    meta: { sitemap: { ignoreRoute: true }, layout: 'base' },
  },
  {
    name: 'clubMembershipStatusPath',
    path: `/${localizedRoutes('path.club_memberships_status')}/:hash`,
    component: view('club/status'),
    meta: { sitemap: { ignoreRoute: true }, layout: 'base' },
  },
  {
    name: 'clubActivation',
    path: `/${localizedRoutes('path.club')}/${localizedRoutes('path.activation')}`,
    component: view('club/activation'),
    meta: { layout: 'base' },
  },
  {
    name: 'cartsPath',
    path: `/${localizedRoutes('path.carts')}`,
    component: view('carts/show'),
    meta: { sitemap: { ignoreRoute: true }, layout: 'base' },
  },
  {
    name: 'mixesPath',
    path: `/${localizedRoutes('path.mixes')}/:permalink`,
    component: view('mixes/index'),
    meta: { sitemap: { slugs: async () => await getMixCategories() }, layout: 'base' },
  },
  {
    name: 'mixesSinglePath',
    path: `/${localizedRoutes('path.mixes-single')}`,
    component: view('mixes/single'),
    meta: { layout: 'base' },
  },
  {
    name: 'faqPath',
    path: `/${localizedRoutes('path.faq')}`,
    component: view('faq/index'),
    meta: { layout: 'base' },
  },
  {
    name: 'mediaPath',
    path: `/${localizedRoutes('path.media')}`,
    component: view('media/index'),
    meta: { layout: 'base' },
  },
  {
    name: 'mediaDetailPath',
    path: `/${localizedRoutes('path.media-detail')}/:permalink`,
    component: view('media/show'),
    meta: { sitemap: { slugs: async () => await getMedia() }, layout: 'base' },
  },
  {
    name: 'mixPath',
    path: `/${localizedRoutes('path.mix')}/:hash`,
    component: view('mix/show'),
    meta: { sitemap: { ignoreRoute: true }, layout: 'base' },
  },
  {
    name: 'mixShortPath',
    path: `/${localizedRoutes('path.mix-short')}/:hash`,
    redirect: (to) => {
      return { path: `/${localizedRoutes('path.mix')}/${to.params.hash}` }
    },
    meta: { sitemap: { ignoreRoute: true }, layout: 'base' },
  },
  {
    name: 'distributorsPath',
    path: `/${localizedRoutes('path.distributors')}`,
    component: view('distributors/index'),
    meta: { layout: 'base' },
  },
  {
    name: 'companyGiftsPath',
    path: `/${localizedRoutes('path.company-gifts')}`,
    component: view('company_gifts/index'),
    meta: { layout: 'base' },
  },
  {
    name: 'bugReportPath',
    path: `/${localizedRoutes('path.bug-report')}`,
    component: view('bug_report/index'),
    meta: { layout: 'base' },
  },
  {
    name: 'complaintsPath',
    path: `/${localizedRoutes('path.complaints')}`,
    component: view('complaints/index'),
    meta: { layout: 'base' },
  },
  {
    name: 'jobOfferPath',
    path: `/${localizedRoutes('path.job-offers')}`,
    component: view('job_offers/index'),
    meta: { layout: 'base' },
  },
  {
    name: 'jobOfferDetailPath',
    path: `/${localizedRoutes('path.job-offers-detail')}/:id`,
    component: view('job_offers/show'),
    meta: { layout: 'base' },
    //meta: { layout: 'base', sitemap: { slugs: async () => await getJobOffers() } },
  },
  {
    name: 'deliveryAndPaymentPath',
    path: `/${localizedRoutes('path.delivery-payment')}`,
    component: view('delivery_and_payment/show'),
    meta: { layout: 'base' },
  },
  {
    name: 'tradeTermsPath',
    path: `/${localizedRoutes('path.trade-terms')}`,
    component: view('trade_terms/show'),
    meta: { layout: 'base' },
  },
  {
    name: 'unsubscribeEmailPath',
    path: `/${localizedRoutes('path.unsubscribe-email')}`,
    component: view('unsubscribe_emails/show'),
    meta: { layout: 'base', blockRobots: true, },
  },
  {
    name: 'subscribeEmailPath',
    path: `/${localizedRoutes('path.subscribe-email')}`,
    component: view('subscribe_emails/show'),
    meta: { layout: 'base' },
  },
  // Static pages
  {
    name: 'mixitAfiliatePath',
    path: `/${localizedRoutes('path.mixit-affiliate')}`,
    component: view('statics/mixitAffiliate'),
    meta: { layout: 'base' },
  },
  {
    name: 'cookiesPath',
    path: `/${localizedRoutes('path.cookies')}`,
    component: view('statics/cookies'),
    meta: { layout: 'base' },
  },
  {
    name: 'privacyTermsPath',
    path: `/${localizedRoutes('path.privacy-terms')}`,
    component: view('statics/privacyTerms'),
    meta: { layout: 'base' },
  },
  {
    name: 'whistleblowingPath',
    path: `/${localizedRoutes('path.whistleblowing')}`,
    component: view('statics/whistleblowing'),
    meta: { layout: 'base' },
  },
  {
    name: 'mixitPlusTermsPath',
    path: `/${localizedRoutes('path.mixit-plus-terms')}`,
    component: view('statics/mixitPlusTerms'),
    meta: { layout: 'base' },
  },
  {
    name: 'affiliateMarketingPath',
    path: `/${localizedRoutes('path.affiliate-marketing')}`,
    component: view('statics/affiliateMarketing'),
    meta: { layout: 'base' },
  },
  {
    name: 'impressumPath',
    path: `/${localizedRoutes('path.impressum')}`,
    component: view('statics/impressum'),
    meta: { layout: 'base' },
  },
  {
    name: 'creditsPage',
    path: `/${localizedRoutes('path.credits-page')}`,
    component: view('credits_page/index'),
    meta: { layout: 'base' },
  },
  {
    name: 'pageNotFound',
    path: '/:pathMatch(.*)*',
    component: view('errors/pageNotFound'),
    meta: { sitemap: { ignoreRoute: true }, layout: 'base' },
  },
]

const checkoutViews = [
  {
    name: 'checkoutPath',
    path: `/${localizedRoutes('path.checkout')}`,
    component: view('checkout/index'),
    meta: {
      sitemap: { ignoreRoute: true },
      blockRobots: true,
      requiresOpenCart: true,
      continuePathName: 'cartsPath',
      customPageView: true,
      preventAppRefresh: true,
      layout: 'checkout',
    },
  },
]

const landingViews = [
  {
    name: 'glutenFreePath',
    path: `/${localizedRoutes('path.gluten_free')}`,
    component: view('landing_pages/category_seller/glutenFree'),
    meta: { layout: 'landing' },
  },
  {
    name: 'sugarFreePath',
    path: `/${localizedRoutes('path.sugar_free')}`,
    component: view('landing_pages/category_seller/sugarFree'),
    meta: { layout: 'landing' },
  },
  {
    name: 'forVeganPath',
    path: `/${localizedRoutes('path.for_vegan')}`,
    component: view('landing_pages/category_seller/forVegan'),
    meta: { layout: 'landing' },
  },
  {
    name: 'withProteinPath',
    path: `/${localizedRoutes('path.with_protein')}`,
    component: view('landing_pages/category_seller/withProtein'),
    meta: { layout: 'landing' },
  },
  {
    name: 'drinksPath',
    path: `/${localizedRoutes('path.drinks')}`,
    component: view('landing_pages/category_seller/drinks'),
    meta: { layout: 'landing' },
  },
  {
    name: 'discountsPath',
    path: `/${localizedRoutes('path.discounts')}`,
    component: view('landing_pages/category_seller/discounts'),
    meta: { layout: 'landing' },
  },
  {
    name: 'valentinePath',
    path: `/${localizedRoutes('path.valentine')}`,
    component: view('landing_pages/valentine/index'),
    meta: { layout: 'landing' },
  },
  {
    name: 'adamOndraPath',
    path: `/${localizedRoutes('path.adam_ondra')}`,
    component: view('landing_pages/adam_ondra/index'),
    meta: { layout: 'landing' },
  },
  {
    name: 'jiriProchazkaPath',
    path: `/${localizedRoutes('path.jiri_prochazka')}`,
    component: view('landing_pages/jiri_prochazka/index'),
    meta: { layout: 'landing' },
  },
  {
    name: 'easterPath',
    path: `/${localizedRoutes('path.easter')}`,
    component: view('landing_pages/easter/index'),
    meta: { layout: 'landing' },
  },
  {
    name: 'cemeteryPath',
    path: `/${localizedRoutes('path.cemetery')}`,
    component: view('landing_pages/cemetery/index'),
    meta: { layout: 'landing' },
  },
  {
    name: 'birthdayPath',
    path: `/${localizedRoutes('path.birthday')}`,
    component: view('landing_pages/birthday/index'),
    meta: { layout: 'landing' },
  },
  {
    name: 'christmasPath',
    path: `/${localizedRoutes('path.christmas')}`,
    component: view('landing_pages/christmas/index'),
    meta: { layout: 'landing' },
  },
  {
    name: 'giftsPath',
    path: `/${localizedRoutes('path.gifts')}`,
    component: view('landing_pages/gifts/index'),
    meta: { layout: 'landing' },
  },
  {
    name: 'retroPath',
    path: `/${localizedRoutes('path.retro')}`,
    component: view('landing_pages/retro/index'),
    meta: { layout: 'landing' },
  },
  {
    name: 'easterGame',
    path: `/${localizedRoutes('path.game-easter')}`,
    component: view('easter_game/index'),
    meta: { layout: 'landing' },
  },
]

export const routes = [
  ...applicationViews,
  ...checkoutViews,
  ...landingViews,
]
